import { clear, unprefix } from '../../../helpers/compact';
import { toText } from '../fields/text';

export const author = (data) => {
  const { fullName, job, phone } = unprefix('author', data);
  if (fullName) {
    return clear({
      fullName: toText(fullName),
      job: toText(job),
      phone: toText(phone),
    });
  }
};
